import { HttpParams } from '@angular/common/http';

export interface PaginationParams {
    page?: number;
    size?: number;
    filter?: string;
    order?: string;
    sort?: string;
}

export const toHttpParams = (paging: PaginationParams): HttpParams => {
    let params: HttpParams = new HttpParams();
    if (paging.size) {
        params = params.set('size', paging.size.toString());
    }
    if (paging.page) {
        params = params.set('page', paging.page.toString());
    }
    if (paging.filter) {
        params = params.set('filter', paging.filter);
    }
    if (paging.sort) {
        params = params.set('sort', paging.sort);
    }
    if (paging.order) {
        params = params.set('order', paging.order);
    }
    return params;
};
